import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalCreditsOptions } from '@panel/commons/lib/Modals/ModalCreditsOptions';

function NormalFlowOffToOnCreditsYes(props) {
  const { onClickCancel, onClickAction, onClickSelect, plans, defaultPlan } = props;
  const { t } = useTranslation();
  useEffect(() => {
    sendTrackingInfo('Mis avisos', 'Republicar Aviso_con credito-Intencion');
  }, []);
  return (
    <ModalCreditsOptions
      onClickAction={onClickAction}
      onClickCancel={onClickCancel}
      onClickSelect={onClickSelect}
      onClickOutside={onClickCancel}
      plans={plans}
      defaultPlan={defaultPlan}
      title={t('panel.modal.NormalFlowOffToOnCreditsYes.title')}
      subTitle={t('panel.modal.NormalFlowOffToOnCreditsYes.subtitle')}
      ctaCancel={t('panel.modal.cta.cancel')}
      ctaOk={t('panel.modal.cta.republish')}
    />
  );
}

export { NormalFlowOffToOnCreditsYes };
